<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Users"
    :breadcrumbs="[
      {
        text: 'Gestión de usuarios',
        disabled: false,
        href: '/admin/user_enterprises'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="profile_picture"
                rules=""
                v-slot="{ errors }"
              >
                <!-- <Upload
                  :error-messages="errors"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen de Perfil"
                  prepend-icon="fas fa-camera"
                  label=""
                  :multiple="false"
                  :onSelectedPicture="onSelectedPicture"
                ></Upload>
                <v-img
                  :src="profile_picture"
                  width="200"
                  style="margin: auto"
                ></v-img> -->
                <Upload
                  :error-messages="errors"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen de Perfil"
                  prepend-icon="fas fa-camera"
                  label=""
                  :defaultImage="profile_picture"
                  :multiple="false"
                  :onSelectedPicture="onSelectedPicture"
                ></Upload>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-4" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Nombre</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  label="Nombre"
                  solo
                  class="input-base"
                  hide-details="auto"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="last_name"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Apellidos</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.last_name"
                  label="Apellido"
                  solo
                  class="input-base"
                  hide-details="auto"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row class="mt-4" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Email</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.email"
                  label="Email"
                  solo
                  hide-details="auto"
                  class="input-base"
                  maxlength="50"
                  :rules="[v => v.length <= 49 || 'Email máximo de 50 caracteres']"
                ></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="password"
                :rules="{ required: !data.id, min: 4 }" 
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Contraseña</div>
                <!-- <v-text-field
                  :error-messages="errors"
                  v-model="data.password"
                  label="Contraseña"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'fas fa-eye' : '$eyesClosed'"
                  @click:append="show1 = !show1"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  solo
                  hide-details="auto"
                  class="input-base"
                ></v-text-field> -->
                <PasswordInput
                  v-model="data.password"
                  :errors="errors"
                  @blur="validate()"
                  :binding="{
                    //class: 'icon-append-16',
                    class: 'input-base',
                    outlined: false,
                    dense: true
                  }"
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row class="mt-4" no-gutters>
            
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="commission_percentage"
                rules="percentage_valid"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Comisión</div>
                <v-text-field
                  name="commission_percentage"
                  label="Comisión"
                  append-icon="$caretDownUpIcon"
                  type="number"
                  solo
                  hide-details="auto"
                  class="input-base no-spinner- custom-number"
                  v-model="data.commission_percentage"
                  :error-messages="errors[0]"
                  :error="errors.length > 0"
                  inputmode="decimal" @keydown="blockE" min="0">
                  <template #prepend-inner>
                    <span class="fonts-s14 fonts-400 fonts-family-DMSans fonts-color-gray3">% </span>
                  </template>

                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="increaseValue">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="decreaseValue">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row class="mt-4" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="access_menus" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Menu</div>
                
                <v-select
                    :error-messages="errors"
                    v-model="data.access_menus"
                    multiple
                    label="Menu"
                    :items="menus"
                    item-text="title"
                    item-value="link"
                    solo
                    class="input-base"
                    hide-details="auto"
                    append-icon="$caretDownFormIcon"
                >
                  <!-- Como se muestran en el input -->
                  <template v-slot:selection="{ item }">
                    {{ item.parent }} - {{ item.title }}
                  </template>

                  <!-- Como se muestran en el dropdown -->
                  <template v-slot:item="{ item, on, attrs, selected }">
                    <v-list-item
                        v-bind="attrs"
                        v-on="on"
                        :class="selected ? 'bg-red white--text' : ''"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.parent }} → {{ item.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>

              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
//import Upload from "@/components/Upload";
import Upload from "@/components/UploadProfile";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import PasswordInput from "@/components/Form/PasswordInput";
export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver, PasswordInput },

  data() {
    return {
      storeName: "User_enterprises",
      title: "Sub Admin",
      filteredAttributes: ["profile_picture"],
      show1: false,
      profile_picture: "",
      data: {
        name: "",
        last_name: "",
        email: "",
        password: "",
        profile_picture: undefined,
        commission_percentage: null,
        access_menus: [],
        user_role: 'admin_enterprise',
      },
      menus: [],
    };
  },
  created() {
    this.menus = this.list_menu.flatMap(parent =>
        parent.children.map(child => ({
          parent: parent.title,
          title: child.title,
          link: child.link
        }))
    );
  },
  computed: {
    ...mapState({
      user: (state) => state.Authenticate.user,
      status: (state) => state.Users.status,
      list_menu: (state) => state.Menu.list,
      list_submenu: (state) => state.Menu.sub_list,
      list_roles: (state) => state.Users.roles,
    }),
  },
  watch: {},
  methods: {
    blockE(e) {
      const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];
      const currentValue = e.target.value;
      if (allowedKeys.includes(e.key)) return;

      if (e.key === "." && !currentValue.includes(".")) return;
      if ((e.key < "0" || e.key > "9") && e.key !== ".") {
        e.preventDefault();
      }
    },
    increaseValue() {
      const val = parseFloat(this.data.commission_percentage || 0);
      this.data.commission_percentage = (val + 1).toString();
    },

    decreaseValue() {
      const val = parseFloat(this.data.commission_percentage || 0);
      if (val > 0) this.data.commission_percentage = (val - 1).toString();
    },
    onSelectedPicture(file) {
      const self = this;
      this.data.profile_picture = file;

      let fr = new FileReader();
      fr.onload = function() {
        self.profile_picture = fr.result;
      };
      fr.onerror = function() {
        self.profile_picture = "";
      };
      fr.readAsDataURL(this.data.profile_picture);
    },
  },
};
</script>
